<script lang="ts">
	import navigation from '../plugins/routes'
	import { path as currentPath, isMobileMenuOpen } from '../store/navigation'
import { fade } from 'svelte/transition'

$: {
  if ($isMobileMenuOpen) {
    document.body.classList.add('no-overflow')
    console.log('yes')

  } else {
    document.body.classList.remove('no-overflow')
    console.log('no')
  }
}

const handleClick = () => {
  isMobileMenuOpen.set(false)
}
</script>

{#if $isMobileMenuOpen}

<div 
  class="mobile-navigation fixed flex md:hidden items-center justify-center inset-0 bg-white z-40"
  transition:fade={{ duration: 250 }}
>
  <ul class="grid justify-items-center">
    {#each navigation as { name, path }, i}
      <li>
        <a class="block p-4 uppercase"
          class:font-semibold="{$currentPath === path}"
          href={path}
          on:click={handleClick}
        >
          {name}
        </a>
      </li>
    {/each}
  </ul>
</div>

{/if}

<style global>
.no-overflow {
  overflow: hidden;
  padding-right: 17px;
}
</style>